import { faLongArrowAltLeft, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import React from 'react';
import './claim-declare-step-actions.scss';

const StepActions = (props) => {
    const { getPreviousView, getNextView, hidePreviousButton, hideNextButton, previousLabel, nextLabel, disabledNext } = props;
    return (
        <div className="row-buttonRow">
            {!hidePreviousButton() &&
                <div className="float-left" >
                    <Button tabIndex={1}
                        onClick={getPreviousView}
                        className="button previousButton btn"
                        disabled={false}
                        type="button"
                        startIcon={<FontAwesomeIcon icon={faLongArrowAltLeft} />}>
                        {previousLabel ? previousLabel : "Précédent"}
                    </Button>
                </div>
            }
            {!hideNextButton() &&
                <div className="float-right" >
                    <Button tabIndex={0}
                        onClick={getNextView}
                        className="button nextButton btn"
                        endIcon={<FontAwesomeIcon icon={faLongArrowAltRight} />}
                        disabled={disabledNext}>
                        {nextLabel ? nextLabel : "Suivant"}
                    </Button>
                </div>
            }
        </div>
    );
};


export default StepActions;
